export default __webpack_public_path__ + "static/media/BulletArrow.bf8c1865.svg";